import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type StepAccessor } from '@/features/jobs/drafting/OutlineViewModel'
import { useObservable } from '@/hooks/rx-hooks'
import { Step } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/Step'

export interface StepContainerProps {
  stepAccessor: StepAccessor
  children?: ReactNode
  isNumbered?: boolean
  /**
   * Leaves out the title and description, for content that heads itself.
   */
  isUntitled?: boolean
  isNotValid?: boolean
  compact?: boolean
}

export const StepContainer = observer(function StepContainer({
  stepAccessor,
  children,
  isNumbered,
  isUntitled,
  isNotValid,
  compact,
}: StepContainerProps) {
  const step = stepAccessor.step

  useObservable(step.becomeActive$, step.onBecameActive)

  return (
    <Step
      title={isUntitled ? '' : step.outlineDisplay.title}
      index={isNumbered ? step.position.index : undefined}
      isLast={step.position.last}
      descriptionHtml={isUntitled ? '' : step.descriptionHtml}
      active={step.isActive}
      becomeActive$={step.becomeActive$}
      onBecomeVisible={step.becomeVisible}
      onBecomeHidden={step.becomeHidden}
      isNotValid={isNotValid}
      testId={`step-${step.stepId}`}
      compact={compact}
    >
      {children}
    </Step>
  )
})
